import { FC } from 'react'
import { BadgeName } from 'src/app/types'
import BadgeSVG from 'src/components/BadgeSVG/BadgeSVG'

type BadgeCountProps = {
  name: BadgeName
  count: number
  isOpen: boolean
  clickable?: boolean
}

const BadgeCount: FC<BadgeCountProps> = ({
  name,
  count,
  isOpen,
  clickable = true,
}) => {
  const Tag = clickable ? 'button' : 'div'

  return (
    <Tag
      className={`inline-flex rounded mr-2 p-1 ${isOpen ? 'bg-lightGrey' : ''}`}
    >
      <p className="mr-1 text-base text-grey">
        <BadgeSVG name={name} />
      </p>
      <p className="text-xs font-normal self-center">{count}</p>
    </Tag>
  )
}

export default BadgeCount
